import { ajaxSend } from 'api/api';
const v1Path = '/v1/messengers';
export function getPlatformApplications(messengerId) {
    return ajaxSend({
        path: `${v1Path}/${messengerId}/platform_application`,
    });
}
